<template>
  <div class="attributes w-full" style="animation-duration: 0.3s">
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Set Attributes
        <i @click="$emit('reset', 'attributes')" class="el-icon-refresh-right float-right text-2xl cursor-pointer"></i>
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <Attributes
        v-for="n in attributeCount"
        :key="n"
        @add="attributeIsValid = true"
        @minus="attributeIsValid = true"
        :count="attributeCount"
        :level="n"
        @isDirty="attributeValidation"
        :action="action"
      />
      <div class="flex items-center" :class="{'justify-between': action === 'create', 'justify-end' : action === 'edit'}">
        <el-button v-if="action === 'create'" @click="$emit('setSteps',{page: 'catalog', step: 1})" type="default">Prev</el-button>
        <el-button v-if="action === 'create'" @click="next()" type="primary">Next</el-button>
        <el-button v-if="action === 'edit'" @click="$emit('updateAttribute')" type="primary">
          <vue-loaders v-if="loading" name="ball-clip-rotate" color="white" scale="0.5"></vue-loaders>
          <span v-if="!loading">Update</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Attributes from './_includes/Attributes.vue';
import ProductMixin from '../../../mixins';

export default {
  name: 'AttributeForm',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'create',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ProductMixin],
  data() {
    return {
      attributeIsValid: true,
    };
  },
  components: {
    Attributes,
  },
  computed: {
    attributeCount() {
      const count = Object.keys(this.$store.state.InventoryModule.Products[this.action].attributes).length;
      if (count === 0) {
        return 1;
      }
      return count;
    },
  },
  methods: {
    attributeValidation(args) {
      this.attributeIsValid = args;
    },

    next() {
      if (this.attributeIsValid) {
        this.$emit('setSteps', { page: 'config', step: 3 });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('InventoryModule/Attributes/fetchAllAttributesGroups');
  },
};
</script>
